import React from 'react';
import { Link } from 'react-router-dom';
import { INSTAGRAM_URL, TIKTOK_URL, SUPPORT_EMAIL, SITE_DOMAIN, TAX_DISCLOSURE } from '../config';
import styles from './Footer.module.css';

export default function Footer({ onGive, onJoin, onNewsletter, links }) {
  const show = (key) => !links || links[key] !== false;
  const year = new Date().getFullYear();

  return (
    <footer className={`${styles.footer} dark-block`}>
      <div className={styles.shell}>
        <div className={styles.top}>
          <Link to="/" className={styles.brand}>
            <img
              src="/images/logo-white.png"
              alt="Revive Worship"
              className={styles.brandLogo}
            />
          </Link>

          <p className={styles.creed}>We exist to <em>worship.</em></p>
        </div>

        <div className={styles.grid}>
          <div className={styles.col}>
            <span className={styles.colLabel}>Navigate</span>
            <Link to="/" className={styles.colLink}>Home</Link>
            {show('about') && <Link to="/about" className={styles.colLink}>About</Link>}
            {show('nights') && <Link to="/nights" className={styles.colLink}>Revive Nights</Link>}
            {show('believe') && <Link to="/believe" className={styles.colLink}>What We Believe</Link>}
            {show('faq') && <Link to="/faq" className={styles.colLink}>FAQ</Link>}
            {/* Static page outside the router — hard link. */}
            {show('yearinreview') && <a href="/yearinreview" className={styles.colLink}>Year in Review</a>}
          </div>

          <div className={styles.col}>
            <span className={styles.colLabel}>Connect</span>
            <a className={styles.colLink} href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
              Instagram <span className={styles.colArrow}>↗</span>
            </a>
            <a className={styles.colLink} href={TIKTOK_URL} target="_blank" rel="noreferrer">
              TikTok <span className={styles.colArrow}>↗</span>
            </a>
            <a className={styles.colLink} href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
          </div>

          <div className={styles.col}>
            <span className={styles.colLabel}>Act</span>
            <button className={styles.colLink} onClick={onJoin}>Join the team</button>
            <button className={styles.colLink} onClick={onNewsletter}>Newsletter signup</button>
            <button className={`${styles.colLink} ${styles.giveLink}`} onClick={onGive}>
              Give to Revive <span className={styles.colArrow}>→</span>
            </button>
          </div>

          <div className={styles.col}>
            <span className={styles.colLabel}>Address</span>
            <p className={styles.address}>
              Pittsburgh, PA<br />
              United States
            </p>
            <p className={styles.legal}>{TAX_DISCLOSURE}</p>
          </div>
        </div>

        <div className={styles.bottom}>
          <span className={styles.copy}>© {year} Revive Worship. All rights reserved.</span>
          <span className={styles.domain}>{SITE_DOMAIN}</span>
          <button className={styles.toTop} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            Back to top <span aria-hidden="true">↑</span>
          </button>
        </div>
      </div>
    </footer>
  );
}
